<template>
  <div>
    <pdf-reader />
    <vx-card id="loading-compliance-card" class="vs-con-loading__container">
      <card-header
        :title="$t('compliance_by_status')"
        v-model="params.search"
        @search="search"
        @close="close"
      />
      <compliance-table
        :data="items"
        @showDetails="showDetails"
        @loadMore="loadMore"
        @search="search"
      />
    </vx-card>
  </div>
</template>

<script>
import ComplianceTable from '../tables/ComplianceTable.vue'
import dashboard from '@/http/requests/dashboard'
import CardHeader from '../components/CardHeader.vue'
import PdfReader from '../components/pdf/PdfReader.vue'
import { BASE_URL, URL_EXPORT_CSV, URL_CUSTOM_REPORT } from '@/urls.js'
import QbTrVue from '../../../qb-components/table/QbTr.vue'
export default {
  name: 'compliance-card',
  components: {
    ComplianceTable,
    CardHeader,
    PdfReader,
  },
  props: {
    data: {
      type: Object,
      required: true,
      default: () => ({}),
    },
  },
  data() {
    return {
      cardTitle: 'Titulo',
      cardId: 'loading-compliance-card',
      items: [],
      complianceId: '',
      lastPage: 1,
      loading: false,
      params: {
        page: 1,
        search: '',
        statusId: 1,
      },
      sentinela: true,
    }
  },
  methods: {
    getData() {
      this.loading = QbTrVue
      this.params.statusId = this.data.statusId
      this.sentinela = false
      console.log(this.params.statusId)
      console.log(this.data.statusId)
      if (this.params.statusId != null) {
        dashboard
          .complianceData(this.params)
          .then((response) => {
            if (this.params.page === 1) {
              this.items = [...response.data.result.data]
            } else {
              this.items = [...this.items, ...response.data.result.data]
            }
            this.lastPage = response.data.result.last_page
            this.loading = false
          })
          .catch((response) => {
            this.showValidationErrors(response)
            this.loading = false
          })
      } else {
        dashboard
          .fullComplianceData(this.params)
          .then((response) => {
            if (this.params.page === 1) {
              this.items = [...response.data.result.data]
            } else {
              this.items = [...this.items, ...response.data.result.data]
            }
            this.lastPage = response.data.result.last_page
            this.loading = false
          })
          .catch((response) => {
            this.showValidationErrors(response)
            this.loading = false
          })
      }
    },
    loadMore() {
      if (this.params.page >= this.lastPage) {
        return
      }
      this.params.page++
      this.getData()
    },
    search() {
      this.params.page = 1
      this.getData()
    },
    showDetails(e) {
      const data = this.items.find((element) => element.id === e)
      this.showPdf(data)
    },
    close() {
      this.$emit('close')
    },
    showPdf(data) {
      let title = `${data.facility} - ${data.client_name} - ${data.title}`
      let files = []
      if (data.file != null) {
        files.push({
          name: 'Compliance',
          source: BASE_URL + 'storage/' + data.file,
        })
      }
      if (data.insurance_file != null) {
        //archivo insurance
        files.push({
          name: 'Insurance',
          source: BASE_URL + 'storage/' + data.insurance_file,
        })
      }

      if (files.length == 0) {
        this.$vs.notify({
          color: 'warning',
          title: 'Not File attached',
          text: 'Not File attached',
        })
        return
      }
      this.$store.dispatch('togglePdfReader', {
        active: true,
        files: files,
        title: title,
      })
    },
  },
  mounted() {
    this.search()
  },
  watch: {
    loading(val) {
      if (val) {
        this.$vs.loading({
          container: `#${this.cardId}`,
          scale: 0.45,
        })
      } else {
        this.$vs.loading.close(`#${this.cardId} > .con-vs-loading`)
      }
    },
    data() {
      this.search()
    },
  },
}
</script>

